function pad(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

export default function formatDurationCell(seconds?: number | null): string {
  if (seconds === null || seconds === undefined) return '—';
  const safe = Math.max(0, Math.round(seconds));
  const h = Math.floor(safe / 3600);
  const m = Math.floor((safe % 3600) / 60);
  const s = safe % 60;
  if (h > 0) return `${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(m)}:${pad(s)}`;
}
